/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lpName: NonNullable<unknown> }} Coinvestments_Contacts_Modal_Description1Inputs */

const en_coinvestments_contacts_modal_description1 = /** @type {(inputs: Coinvestments_Contacts_Modal_Description1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Organisation users associated with ${i?.lpName}. To manage contacts and permissions, use the Share button on the Outreach tab.`)
};

/**
* | output |
* | --- |
* | "Organisation users associated with {lpName}. To manage contacts and permissions, use the Share button on the Outreach tab." |
*
* @param {Coinvestments_Contacts_Modal_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_contacts_modal_description1 = /** @type {((inputs: Coinvestments_Contacts_Modal_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Contacts_Modal_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_contacts_modal_description1(inputs)
});
export { coinvestments_contacts_modal_description1 as "coInvestments_contacts_modal_description" }